import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React from 'react';
import { IStyle } from 'Styles';

export interface HeaderContentProps {
  title: string;
  lastActionPerformed: string;
  enableDelete: boolean;
  onClickOR: () => void;
  onClickAND: () => void;
  onClickDelete: () => void;
}
const HeaderContent = (props: HeaderContentProps) => {
  const {
    title,
    lastActionPerformed,
    enableDelete,
    onClickOR,
    onClickAND,
    onClickDelete,
  } = props;

  const renderHeaderButtons = (
    onClick: () => void,
    iconSvgName,
    lastActionPerformed,
    enableDelete,
  ) => {
    return (
      <RMCustomButton
        customStyle={{ float: 'left' }}
        iconProps={{
          name: iconSvgName,
          width: '25px',
          height: '25px',
          fill: !lastActionPerformed
            ? enableDelete
              ? '#DA1E28'
              : '#CACACA'
            : lastActionPerformed.toUpperCase() == iconSvgName
            ? '#AACDFC'
            : 'transparent',
        }}
        onClick={onClick}
      />
    );
  };
  return (
    <div id='exp-finddrop-headercontent-wrapper' style={styles.headerScoresIngs}>
      <div id='exp-finddrop-headercontent-left' style={styles.leftHeaderSection}>
        <div id={`exp-finddrop-headercontent-${title}-info`} style={styles.headerInfoContent}>{title}</div>
      </div>
      <div id={`exp-finddrop-headercontent-section1-clear-button`} style={styles.buttonSection1}>
        <div id={`exp-finddrop-headercontent-section2-or-and--button`} style={styles.buttonSection2}>
          {renderHeaderButtons(onClickOR, 'OR', lastActionPerformed, false)}
          {renderHeaderButtons(onClickAND, 'AND', lastActionPerformed, false)}
        </div>
        {renderHeaderButtons(onClickDelete, 'Clear', '', enableDelete)}
      </div>
    </div>
  );
};

export const styles: IStyle = {
  headerScoresIngs: {
    display: 'flex',
    width: '100%',
    minHeight: '5vh',
    backgroundColor: '#F5F5F5',

    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: '0',
  },
  buttonSection1: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '5%',
  },
  buttonSection2: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '10%',
  },
  leftHeaderSection: {
    marginLeft: '1.5%',
    display: 'flex',
    gap: '1%',
  },
  headerInfoContent: {
    fontWeight: 600,
    textOverflow: 'ellipsis',
    overflow: 'clip',
    marginBlock: 'auto',
  },
};
export default HeaderContent;
